import React from 'react'

import { DICTIONARY } from '../../../../constants/dictionary'
import { Entry } from '../../../../model/Entry'
import DetailsSection from './DetailsSection'

interface Props {
  details: Entry[]
}

const OptionDetailsSection: React.FC<Props> = ({ details }) => {
  return (
    <DetailsSection
      title={DICTIONARY.QUOTE_SUMMARY_PACKS_AND_OPTIONS_LABEL}
      details={details}
      testId="OptionDetailsSection"
    />
  )
}

export default OptionDetailsSection
